export default new Map<string, string>([
  ['1', 'uomo'],
  ['2', 'donna'],
  ['3', 'unisex'],
]);
